module.exports = __webpack_public_path__ + "img/logo-rz.39b356fb.svg";